<script setup lang="ts">
export interface WidgetQuickSearchProps {
    searchTermMin?: number
}

const props = withDefaults(defineProps<WidgetQuickSearchProps>(), {
    searchTermMin: 1, // minimum character length of a valid search term
})

const searchTerm = ref<string>('')
const localePath = useLocalePath()
const { formatLink } = useInternationalization(localePath)

// used for submitting the search form (fallback when the Doofinder Search Layer is unavailable)
async function onSearchSubmit (): Promise<void> {
    if (searchTerm?.value?.length <= props.searchTermMin) return
    navigateTo(formatLink(`/search?search=${searchTerm.value}`))
}

function onReset () {
    searchTerm.value = ''
}
</script>

<template>
    <div @keydown.esc="onReset">
        <form role="search" class="relative" @submit.prevent="onSearchSubmit">
            <SearchInput
                v-model="searchTerm"
                :label="$t('search.input.label')"
                :placeholder="$t('search.input.placeholder')"
                @submit-search="onSearchSubmit"
                @reset-search="onReset"
            />
        </form>
    </div>
</template>
